import { useQueryClient } from '@tanstack/react-query';
import { useCustomMutation } from 'hooks/api/useCustomMutation';
import { API_FUNCTIONS, checkIfGreatSuccess, queryKeys, RULES_ENDPOINTS, sdk } from 'utils/query';
import { WorklistStatus } from 'models/worklist';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { ApiTaskResult } from 'models/general';

export const updateWorklistRecord = async (variables: { id?: string; status: WorklistStatus }) => {
  const { id, status } = variables;

  if (!id) throw new EmptyParametersError();

  const result = await sdk.tasks.api.post<ApiTaskResult, unknown>(
    API_FUNCTIONS.monitoring,
    `${RULES_ENDPOINTS.monitoringNotifications}/${id}/${status}`,
    {},
    {},
  );
  return checkIfGreatSuccess({ result });
};

export const useUpdateWorklistRecord = () => {
  const queryClient = useQueryClient();

  return useCustomMutation({
    fn: updateWorklistRecord,
    onSuccess: {
      callback: async (_result, variables) => {
        await queryClient.invalidateQueries({ queryKey: [queryKeys.worklistRecord, variables.id] });
      },
    },
  });
};
